import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAuthContext } from '../contexts/authContext';
import PublicRoute from './publicRoute';
import PrivateRoute from './privateRoute';
import {
    EXPIRATIONTOKEN,
    HOME,
    SIGNIN,
    REDIRECTLIST,
    REDIRECTNEW,
    REDIRECTEDIT,
    USERS,
    USERLIST,
    USERNEW,
    USEREDIT,
    PAGENOTFOUND,
    CHATVIDEO,
    CHAT,
    EXPORT,
    MODULES,
    ACCOUNTS,
    ACCOUNTS_NEW,
    ACCOUNTS_EDIT,
    PQR,
    ACCOUNTS_DETAIL,
    PQR_EDIT,
    PQR_DETAIL,
    PQR_HISTORY,
    INITIAL_CAUSALITY,
    INITIAL_CAUSALITY_NEW,
    INITIAL_CAUSALITY_EDIT,
    INITIAL_CAUSALITY_DETAIL,
    SARLAFT,
    SARLAFT_EDIT,
    SARLAFT_DETAIL,
    PQRWEB,
    CASES_GENERAL_INFORMATION,
    CASES_GENERAL_INFORMATION_DETAIL,
    CASES_GENERAL_INFORMATION_EDIT,
    PQRWEB_CREATE,
    PQRWEB_SEARCH,
    PQRWEB_SURVEY,
    CASES_GENERAL,
    CASES_GENERAL_EDIT,
    CASES_GENERAL_DETAIL,
    PQR_MANAGEMENT,
    LEGAL_PROCEEDINGS,
    LEGAL_PROCEEDINGS_NEW,
    LEGAL_PROCEEDINGS_EDIT,
    LEGAL_PROCEEDINGS_DETAIL,
    SAMPLES,
    SAMPLES_DETAIL,
    SAMPLES_EDIT,
    ORBIT,
    PQRWEB_SURVEY_RESPONSE,
    TYPIFICATIONS,
    FINAL_CAUSALITY,
    FINAL_CAUSALITY_NEW,
    FINAL_CAUSALITY_EDIT,
    FINAL_CAUSALITY_DETAIL,
    CHANNELSSMSFORM,
    CHANNELSMSFORMTHANKYOU,
    SYSTEMCONFIG,
    MOTIVE,
    MOTIVE_NEW,
    MOTIVE_EDIT,
    MOTIVE_DETAIL,
    REDIRECT_DETAIL,
    PQR_SURVEY_DETAIL,
    PROCEDURE,
    PROCEDURE_EDIT,
    PROCEDURE_DETAIL,
    PROCEDURE_NEW,
    PQR_TYPE,
    PQR_TYPE_NEW,
    PQR_TYPE_EDIT,
    PQR_TYPE_DETAIL,
    SUBTYPE_DP,
    SUBTYPE_DP_NEW,
    SUBTYPE_DP_EDIT,
    SUBTYPE_DP_DETAIL,
    SWITCH,
    SWITCH_DETAIL,
    SWITCH_EDIT,
    QUOTATION,
    QUOTATION_DETAIL,
    QUOTATION_EDIT,
    EMAIL_SENDING,
    SUBMOTIVE1,
    SUBMOTIVE1_NEW,
    SUBMOTIVE1_EDIT,
    SUBMOTIVE1_DETAIL,
    SUBMOTIVE2,
    SUBMOTIVE2_NEW,
    SUBMOTIVE2_EDIT,
    SUBMOTIVE2_DETAIL,
    SUBMOTIVE3,
    SUBMOTIVE3_NEW,
    SUBMOTIVE3_EDIT,
    SUBMOTIVE3_DETAIL,
    SUBMOTIVE4,
    SUBMOTIVE4_NEW,
    SUBMOTIVE4_EDIT,
    SUBMOTIVE4_DETAIL,
    PQR_RECEPTION_CHANNEL,
    PQR_RECEPTION_CHANNEL_NEW,
    PQR_RECEPTION_CHANNEL_EDIT,
    PQR_RECEPTION_CHANNEL_DETAIL,
    PRODUCT,
    PRODUCT_DETAIL,
    PRODUCT_EDIT,
    PRODUCT_NEW,
    PQR_RECEIVED_THROUGH,
    PQR_RECEIVED_THROUGH_NEW,
    PQR_RECEIVED_THROUGH_EDIT,
    PQR_RECEIVED_THROUGH_DETAIL,
    UPDATE_PASSWORD,
    REDIRECTMODULE,
    REDIRECT_AREA,
    REDIRECT_AREA_NEW,
    REDIRECT_AREA_EDIT,
    REDIRECT_AREA_DETAIL,
    FRAUD_MODE,
    FRAUD_MODE_NEW,
    FRAUD_MODE_EDIT,
    FRAUD_MODE_DETAIL,
    FRAUD_TYPE_NEW,
    FRAUD_TYPE_EDIT,
    FRAUD_TYPE,
    FRAUD_TYPE_DETAIL,
    PQR_TIMES,
    PQR_TIMES_NEW,
    PQR_TIMES_EDIT,
    PQR_TIMES_DETAIL,
    CHAT_WEB,
    CHAT_BOT,
    FUNCTIONARIES_SWITCHBOARD,
    FUNCTIONARIES_SWITCHBOARD_NEW,
    FUNCTIONARIES_SWITCHBOARD_EDIT,
    FUNCTIONARIES_SWITCHBOARD_DETAIL,
    COMPLIANCE_TERMS,
    COMPLIANCE_TERMS_NEW,
    COMPLIANCE_TERMS_EDIT,
    COMPLIANCE_TERMS_DETAIL,
    ALERTS,
    ALERTS_NEW,
    ALERTS_EDIT,
    ALERTS_DETAIL,
    SURVEYS,
    SURVEYS_NEW,
    SURVEYS_EDIT,
    SURVEYS_DETAIL,
    SURVEYS_RENDER,
    SURVEYS_RESPONSES,
    SURVEYS_RESPONSES_DETAIL,
    // CASES_GENERAL_CREATE,
} from './paths';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import variables from '../shared/styles/settings.module.scss';
import SignIn from '../components/pages/auth/signIn';
import Home from '../components/pages/home/home';
import { Users } from '../components/pages/users';
import UserNew from '../components/pages/users/new';
import EditUser from '../components/pages/users/edit';
import { UpdatePasswordUser } from '../components/pages/auth/updatePassword';
import ExpirationToken from '../components/components/views/expirationToken';
import PageNotFound from '../components/components/views/pageNotFound';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import ChatVideo from '../components/pages/chatvideo/chat';
import ChatWeb from '../components/pages/chatWeb/chat';
import Export from '../components/pages/export/export';
import { Accounts } from '../components/pages/modules/accounts';
import { AccountForm } from '../components/pages/modules/accounts/form';
import { Pqr } from '../components/pages/modules/pqr';
import { AccountDetail } from '../components/pages/modules/accounts/detail';
import { PqrDetail } from '../components/pages/modules/pqr/detail';
import { PqrFormEdit } from '../components/pages/modules/pqr/formEdit';
import { Sarlaft } from '../components/pages/modules/sarlaft';
import { SarlaftForm } from '../components/pages/modules/sarlaft/form';
import { SarlaftDetail } from '../components/pages/modules/sarlaft/detail';
import { PqrWeb } from '../components/pages/modules/pqr_web';
import { CasesGeneralInformation } from '../components/pages/modules/casesGeneralInformation';
import { CasesGeneralInformationDetail } from '../components/pages/modules/casesGeneralInformation/detail';
import { CasesGeneralInformationForm } from '../components/pages/modules/casesGeneralInformation/form';
import { Switch } from '../components/pages/modules/switch';
import { SwitchDetail } from '../components/pages/modules/switch/detail';
import { SwitchForm } from '../components/pages/modules/switch/form';
import { PqrWebCreate } from '../components/pages/modules/pqr_web/form';
import { PqrFiltersWeb } from '../components/pages/modules/pqr_web/filters';
import { CasesGeneral } from '../components/pages/modules/casesGeneral';
import { CasesGeneralForm } from '../components/pages/modules/casesGeneral/form';
import { CaseGeneralDetail } from '../components/pages/modules/casesGeneral/detail';
import { RedirectParams } from '../components/pages/redirect/redirectPerson';
import { RedirectPqrForm } from '../components/pages/redirect/redirectPerson/form';
import { RedirectPqrDetail } from '../components/pages/redirect/redirectPerson/detail';
import { LegalProceedings } from '../components/pages/pqrManagement/legalProceedings';
import { LegalProceedingsForm } from '../components/pages/pqrManagement/legalProceedings/form';
import { LegalProceedingsDetail } from '../components/pages/pqrManagement/legalProceedings/detail';

import { AlertsForm } from '../components/pages/pqrManagement/alerts/form';
import { Alerts } from '../components/pages/pqrManagement/alerts';
import { AlertsDetail } from '../components/pages/pqrManagement/alerts/detail';

import { Samples } from '../components/pages/pqrManagement/samples';
import { OrbitHistory, OrbitRadication } from '../components/pages/orbit';
import { PqrSurveyForm } from '../components/pages/modules/pqr_web/survey';
import { PqrHistory } from '../components/pages/modules/pqr_history';
import { InitialCausality } from '../components/pages/typifications/initialCausality';
import { InitialCausalityForm } from '../components/pages/typifications/initialCausality/form';
import { InitialCausalityDetail } from '../components/pages/typifications/initialCausality/detail';
import { FinalCausality } from '../components/pages/typifications/finalCausality';
import { FinalCausalityForm } from '../components/pages/typifications/finalCausality/form';
import { FinalCausalityDetail } from '../components/pages/typifications/finalCausality/detail';
import { ChannelsWeb } from '../components/pages/modules/updateChannelsSms';
import { ChannelsWebThankYou } from '../components/pages/modules/updateChannelsSms/info';
import { MotiveForm } from '../components/pages/systemConfig/motives/form';
import { Motive } from '../components/pages/systemConfig/motives';
import { MotiveDetail } from '../components/pages/systemConfig/motives/detail';
import { PqrSurveyDetail } from '../components/pages/modules/pqr/surveyDetail';
import { ProcedureParams } from '../components/pages/systemConfig/procedureParams';
import { ProcedureDetail } from '../components/pages/systemConfig/procedureParams/detail';
import { ProcedureForm } from '../components/pages/systemConfig/procedureParams/form';
import { PqrType } from '../components/pages/systemConfig/pqrTypes';
import { PqrTypeForm } from '../components/pages/systemConfig/pqrTypes/form';
import { PqrTypeDetail } from '../components/pages/systemConfig/pqrTypes/detail';
import { SubtypeDP } from '../components/pages/systemConfig/subtypesDP';
import { SubtypeDPDetail } from '../components/pages/systemConfig/subtypesDP/detail';
import { SubtypeDPForm } from '../components/pages/systemConfig/subtypesDP/form';
import { Submotive1 } from '../components/pages/systemConfig/submotives1';
import { Submotive1Detail } from '../components/pages/systemConfig/submotives1/detail';
import { Submotive1Form } from '../components/pages/systemConfig/submotives1/form';
import { Submotive2 } from '../components/pages/systemConfig/submotives2';
import { Submotive2Detail } from '../components/pages/systemConfig/submotives2/detail';
import { Submotive2Form } from '../components/pages/systemConfig/submotives2/form';
import { Submotive3 } from '../components/pages/systemConfig/submotives3';
import { Submotive3Detail } from '../components/pages/systemConfig/submotives3/detail';
import { Submotive3Form } from '../components/pages/systemConfig/submotives3/form';

import { Quotation } from '../components/pages/modules/quotation';
import { QuotationForm } from '../components/pages/modules/quotation/form';
import { QuotationDetail } from '../components/pages/modules/quotation/detail';
import { EmailSending } from '../components/pages/modules/emailSending';
import { Submotive4 } from '../components/pages/systemConfig/submotives4';
import { Submotive4Detail } from '../components/pages/systemConfig/submotives4/detail';
import { Submotive4Form } from '../components/pages/systemConfig/submotives4/form';
import { PqrReceptionChannel } from '../components/pages/systemConfig/pqrReceptionChannel';
import { PqrReceptionChannelDetail } from '../components/pages/systemConfig/pqrReceptionChannel/detail';
import { PqrReceptionChannelForm } from '../components/pages/systemConfig/pqrReceptionChannel/form';
import { Product } from '../components/pages/systemConfig/products';
import { ProductDetail } from '../components/pages/systemConfig/products/detail';
import { ProductForm } from '../components/pages/systemConfig/products/form';
import { PqrReceivedThrough } from '../components/pages/systemConfig/pqrReceivedThrough';
import { PqrReceivedThroughForm } from '../components/pages/systemConfig/pqrReceivedThrough/form';
import { PqrReceivedThroughDetail } from '../components/pages/systemConfig/pqrReceivedThrough/detail';
import Loading from '../components/components/general/loadings/loading';
import { RedirectArea } from '../components/pages/redirect/redirectArea';
import { RedirectAreaDetail } from '../components/pages/redirect/redirectArea/detail';
import { RedirectAreaForm } from '../components/pages/redirect/redirectArea/form';
import { FraudMode } from '../components/pages/systemConfig/fraudMode';
import { FraudModeForm } from '../components/pages/systemConfig/fraudMode/form';
import { FraudModeDetail } from '../components/pages/systemConfig/fraudMode/detail';
import { FraudType } from '../components/pages/systemConfig/fraudType';
import { FraudTypeForm } from '../components/pages/systemConfig/fraudType/form';
import { FraudTypeDetail } from '../components/pages/systemConfig/fraudType/detail';
import { PqrTimes } from '../components/pages/systemConfig/pqrTimes';
import { PqrTimesForm } from '../components/pages/systemConfig/pqrTimes/form';
import { PqrTimesDetail } from '../components/pages/systemConfig/pqrTimes/detail';
import { ChatWebPage } from '../components/pages/chatWebPage/chat';
import { ChatbotScript } from '../components/pages/chatWebPage/chatbotScript';
import FunctionariesSwitchboard from '../components/pages/systemConfig/functionariesSwitchBoard';
import { FunctionariesSwitchForm } from '../components/pages/systemConfig/functionariesSwitchBoard/form';
import { FunctionariesSwitchDetail } from '../components/pages/systemConfig/functionariesSwitchBoard/detail';

import { ComplianceTerms } from '../components/pages/systemConfig/complianceTerms';
import { ComplianceTermsForm } from '../components/pages/systemConfig/complianceTerms/form';
import { ComplianceTermsDetail } from '../components/pages/systemConfig/complianceTerms/detail';
import { Surveys } from '../components/pages/systemConfig/surveys';
import { SurveyForm } from '../components/pages/systemConfig/surveys/form';
import { SurveyDetail } from '../components/pages/systemConfig/surveys/detail';
import { SurveyLogs } from '../components/pages/systemConfig/surveys/logs';
import { SurveyResponses } from '../components/pages/systemConfig/surveyResponses';
import { SurveyResponseDetail } from '../components/pages/systemConfig/surveyResponses/detail';
import SurveyRender from '../components/pages/systemConfig/surveys/render';

const AppRoutes = () => {
    const { modeTheme } = useAuthContext();
    const { logUser, isLoadingUser } = useSelector(
        (state: RootState) => state.general
    );
    const { type } = logUser || {};

    const theme = createTheme(
        {
            palette:
                modeTheme === 'darkMode'
                    ? {
                        // palette values for dark mode
                        primary: {
                            main: variables.darkColor,
                            contrastText: variables.whiteColor,
                            dark: variables.greyColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    }
                    : {
                        // palette values for light mode
                        primary: {
                            main: variables.primaryColor,
                            contrastText: variables.whiteColor,
                            dark: variables.quinaryColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                    },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 500,
                    md: 800,
                    lg: 1200,
                    xl: 1536,
                },
            },
        },
        esES
    );

    return (
        <ThemeProvider theme={theme}>
            {isLoadingUser && logUser === undefined ? (
                <Loading />
            ) : (
                <Router>
                    <Routes>
                        <Route path={HOME} element={<PrivateRoute />}>
                            <Route index element={<Home />} />
                        </Route>
                        <Route path={MODULES} element={<PrivateRoute />}>
                            <Route
                                path={`${ACCOUNTS}/:documentAccount?`}
                                element={<Accounts />}
                            />
                            <Route
                                path={ACCOUNTS_NEW}
                                element={<AccountForm />}
                            />
                            {[
                                'admin',
                                'backoffice',
                                'agent',
                                'supervisor',
                                'agente-conmutador',
                            ].includes(type) && (
                                <Route
                                    path={`${ACCOUNTS_EDIT}/:idAccount`}
                                    element={<AccountForm />}
                                />
                            )}
                            <Route
                                path={`${ACCOUNTS_DETAIL}/:idAccount`}
                                element={<AccountDetail />}
                            />
                            <Route path={`${PQR}/:pqrId?`} element={<Pqr />} />
                            {[
                                'admin',
                                'backoffice',
                                'supervisor',
                                'cliente',
                            ].includes(type) && (
                                <Route
                                    path={`${PQR_EDIT}/:idPqr`}
                                    element={<PqrFormEdit showFormView />}
                                />
                            )}
                            <Route
                                path={`${PQR_DETAIL}/:idPqr`}
                                element={<PqrDetail samples={false} />}
                            />
                            <Route
                                path={`${PQR_SURVEY_DETAIL}/:idPqr`}
                                element={<PqrSurveyDetail />}
                            />
                            <Route
                                path={PQR_HISTORY}
                                element={<PqrHistory />}
                            />

                            <Route
                                path={`${SARLAFT}/:sarlaftId?`}
                                element={<Sarlaft />}
                            />
                            {['admin', 'backoffice'].includes(type) && (
                                <Route
                                    path={`${SARLAFT_EDIT}/:idSarlaft`}
                                    element={<SarlaftForm showFormView />}
                                />
                            )}
                            <Route
                                path={`${SARLAFT_DETAIL}/:idSarlaft`}
                                element={<SarlaftDetail />}
                            />
                            <Route
                                path={`${CASES_GENERAL_INFORMATION}`}
                                element={<CasesGeneralInformation />}
                            />
                            {['admin', 'backoffice'].includes(type) && (
                                <Route
                                    path={`${CASES_GENERAL_INFORMATION_EDIT}/:idCasesGeneralInformation`}
                                    element={
                                        <CasesGeneralInformationForm
                                            showFormView
                                        />
                                    }
                                />
                            )}
                            <Route
                                path={`${CASES_GENERAL_INFORMATION_DETAIL}/:idCasesGeneralInformation`}
                                element={<CasesGeneralInformationDetail />}
                            />

                            <Route path={`${SWITCH}`} element={<Switch />} />
                            {['admin', 'backoffice'].includes(type) && (
                                <Route
                                    path={`${SWITCH_EDIT}/:idSwitch`}
                                    element={<SwitchForm showFormView />}
                                />
                            )}

                            <Route
                                path={`${SWITCH_DETAIL}/:idSwitch`}
                                element={<SwitchDetail />}
                            />
                            <Route
                                path={`${CASES_GENERAL}`}
                                element={<CasesGeneral />}
                            />
                            {['admin', 'backoffice'].includes(type) && (
                                <Route
                                    path={`${CASES_GENERAL_EDIT}/:idCasesGeneral`}
                                    element={<CasesGeneralForm showFormView />}
                                />
                            )}
                            <Route
                                path={`${CASES_GENERAL_DETAIL}/:idQuotation`}
                                element={<CaseGeneralDetail />}
                            />
                            <Route
                                path={`${QUOTATION}`}
                                element={<Quotation />}
                            />
                            {[
                                'admin',
                                'backoffice',
                                'backoffice-cotizador',
                                'agent',
                            ].includes(type) && (
                                <Route
                                    path={`${QUOTATION_EDIT}/:idQuotation`}
                                    element={<QuotationForm showFormView />}
                                />
                            )}
                            <Route
                                path={`${QUOTATION_DETAIL}/:idQuotation`}
                                element={<QuotationDetail />}
                            />
                            <Route
                                path={`${EMAIL_SENDING}`}
                                element={<EmailSending />}
                            />
                            <Route path={SURVEYS} element={<Surveys />} />
                            {['admin', 'supervisor'].includes(type) && (
                                <>
                                    <Route
                                        path={SURVEYS_NEW}
                                        element={<SurveyForm />}
                                    />
                                    <Route
                                        path={`${SURVEYS_EDIT}/:id`}
                                        element={<SurveyForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SURVEYS_DETAIL}/:id`}
                                element={<SurveyDetail />}
                            />
                            <Route
                                path={`${SURVEYS}/logs/:id`}
                                element={<SurveyLogs />}
                            />
                            <Route
                                path={SURVEYS_RESPONSES}
                                element={<SurveyResponses />}
                            />
                            <Route
                                path={SURVEYS_RESPONSES_DETAIL}
                                element={<SurveyResponseDetail />}
                            />
                        </Route>
                        <Route path={PQR_MANAGEMENT} element={<PrivateRoute />}>
                            <Route
                                path={LEGAL_PROCEEDINGS}
                                element={<LegalProceedings />}
                            />
                            <Route
                                path={LEGAL_PROCEEDINGS_NEW}
                                element={<LegalProceedingsForm showFormView />}
                            />
                            {['admin', 'backoffice', 'supervisor'].includes(
                                type
                            ) && (
                                <Route
                                    path={`${LEGAL_PROCEEDINGS_EDIT}/:idLegalProceeding`}
                                    element={
                                        <LegalProceedingsForm showFormView />
                                    }
                                />
                            )}
                            <Route
                                path={`${LEGAL_PROCEEDINGS_DETAIL}/:idLegalProceeding`}
                                element={<LegalProceedingsDetail />}
                            />

                            <Route path={ALERTS} element={<Alerts />} />
                            <Route
                                path={`${ALERTS_NEW}/:arrayPqr?`}
                                element={<AlertsForm />}
                            />
                            {['admin', 'backoffice', 'supervisor'].includes(
                                type
                            ) && (
                                <Route
                                    path={`${ALERTS_EDIT}/:idAlert`}
                                    element={<AlertsForm />}
                                />
                            )}
                            <Route
                                path={`${ALERTS_DETAIL}/:idAlert`}
                                element={<AlertsDetail />}
                            />

                            <Route path={SAMPLES} element={<Samples />} />
                            {['admin', 'backoffice', 'supervisor'].includes(
                                type
                            ) && (
                                <Route
                                    path={`${SAMPLES_EDIT}/:idPqr`}
                                    element={
                                        <PqrFormEdit showFormView isSample />
                                    }
                                />
                            )}
                            <Route
                                path={`${SAMPLES_DETAIL}/:idPqr`}
                                element={<PqrDetail samples={true} />}
                            />
                        </Route>
                        {process.env.REACT_APP_ORBIT_RADICATION_ENABLED ===
                            'true' && (
                            <Route path={ORBIT} element={<PrivateRoute />}>
                                <Route index element={<OrbitRadication />} />
                                <Route
                                    path="history"
                                    element={<OrbitHistory />}
                                />
                                <Route
                                    path="detail/:caseId"
                                    element={<OrbitRadication />}
                                />
                            </Route>
                        )}
                        {[
                            'admin',
                            'supervisor',
                            'formador',
                            'calidad',
                            'cliente',
                        ].includes(type) && (
                            <>
                                <Route
                                    path={TYPIFICATIONS}
                                    element={<PrivateRoute />}
                                >
                                    <Route
                                        path={FINAL_CAUSALITY}
                                        element={<FinalCausality />}
                                    />
                                    <Route
                                        path={FINAL_CAUSALITY_NEW}
                                        element={<FinalCausalityForm />}
                                    />
                                    {[
                                        'admin',
                                        'backoffice',
                                        'supervisor',
                                    ].includes(type) && (
                                        <Route
                                            path={`${FINAL_CAUSALITY_EDIT}/:idFinalCausality`}
                                            element={<FinalCausalityForm />}
                                        />
                                    )}
                                    <Route
                                        path={`${FINAL_CAUSALITY_DETAIL}/:idFinalCausality`}
                                        element={<FinalCausalityDetail />}
                                    />
                                </Route>
                                <Route
                                    path={TYPIFICATIONS}
                                    element={<PrivateRoute />}
                                >
                                    <Route
                                        path={INITIAL_CAUSALITY}
                                        element={<InitialCausality />}
                                    />
                                    <Route
                                        path={INITIAL_CAUSALITY_NEW}
                                        element={<InitialCausalityForm />}
                                    />
                                    {[
                                        'admin',
                                        'backoffice',
                                        'supervisor',
                                    ].includes(type) && (
                                        <Route
                                            path={`${INITIAL_CAUSALITY_EDIT}/:idInitialCausality`}
                                            element={<InitialCausalityForm />}
                                        />
                                    )}
                                    <Route
                                        path={`${INITIAL_CAUSALITY_DETAIL}/:idInitialCausality`}
                                        element={<InitialCausalityDetail />}
                                    />
                                </Route>
                            </>
                        )}

                        <Route path={REDIRECTMODULE} element={<PrivateRoute />}>
                            <Route
                                path={REDIRECTLIST}
                                element={<RedirectParams />}
                            />
                            {['admin', 'supervisor'].includes(type) && (
                                <>
                                    <Route
                                        path={REDIRECTNEW}
                                        element={<RedirectPqrForm />}
                                    />
                                    <Route
                                        path={`${REDIRECTEDIT}/:idRedirect`}
                                        element={<RedirectPqrForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${REDIRECT_DETAIL}/:idRedirect`}
                                element={<RedirectPqrDetail />}
                            />
                        </Route>
                        <Route path={REDIRECTMODULE} element={<PrivateRoute />}>
                            <Route
                                path={REDIRECT_AREA}
                                element={<RedirectArea />}
                            />
                            {['admin', 'supervisor'].includes(type) && (
                                <>
                                    <Route
                                        path={REDIRECT_AREA_NEW}
                                        element={<RedirectAreaForm />}
                                    />
                                    <Route
                                        path={`${REDIRECT_AREA_EDIT}/:idRedirectArea`}
                                        element={<RedirectAreaForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${REDIRECT_AREA_DETAIL}/:idRedirectArea`}
                                element={<RedirectAreaDetail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={MOTIVE} element={<Motive />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={MOTIVE_NEW}
                                        element={<MotiveForm />}
                                    />
                                    <Route
                                        path={`${MOTIVE_EDIT}/:name/:active`}
                                        element={<MotiveForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${MOTIVE_DETAIL}/:name/:active`}
                                element={<MotiveDetail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={SUBMOTIVE1} element={<Submotive1 />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={SUBMOTIVE1_NEW}
                                        element={<Submotive1Form />}
                                    />
                                    <Route
                                        path={`${SUBMOTIVE1_EDIT}/:idSubmotive1`}
                                        element={<Submotive1Form />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SUBMOTIVE1_DETAIL}/:idSubmotive1`}
                                element={<Submotive1Detail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={SUBMOTIVE2} element={<Submotive2 />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={SUBMOTIVE2_NEW}
                                        element={<Submotive2Form />}
                                    />
                                    <Route
                                        path={`${SUBMOTIVE2_EDIT}/:idSubmotive2`}
                                        element={<Submotive2Form />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SUBMOTIVE2_DETAIL}/:idSubmotive2`}
                                element={<Submotive2Detail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={SUBMOTIVE4} element={<Submotive4 />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={SUBMOTIVE4_NEW}
                                        element={<Submotive4Form />}
                                    />
                                    <Route
                                        path={`${SUBMOTIVE4_EDIT}/:idSubmotive4`}
                                        element={<Submotive4Form />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SUBMOTIVE4_DETAIL}/:idSubmotive4`}
                                element={<Submotive4Detail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={SUBMOTIVE3} element={<Submotive3 />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={SUBMOTIVE3_NEW}
                                        element={<Submotive3Form />}
                                    />
                                    <Route
                                        path={`${SUBMOTIVE3_EDIT}/:idSubmotive3`}
                                        element={<Submotive3Form />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SUBMOTIVE3_DETAIL}/:idSubmotive3`}
                                element={<Submotive3Detail />}
                            />
                        </Route>
                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={PROCEDURE}
                                element={<ProcedureParams />}
                            />
                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PROCEDURE_NEW}
                                        element={<ProcedureForm />}
                                    />
                                    <Route
                                        path={`${PROCEDURE_EDIT}/:idProcedure`}
                                        element={<ProcedureForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PROCEDURE_DETAIL}/:idProcedure`}
                                element={<ProcedureDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={PQR_TYPE} element={<PqrType />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PQR_TYPE_NEW}
                                        element={<PqrTypeForm />}
                                    />
                                    <Route
                                        path={`${PQR_TYPE_EDIT}/:idPqrType`}
                                        element={<PqrTypeForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PQR_TYPE_DETAIL}/:idPqrType`}
                                element={<PqrTypeDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={SUBTYPE_DP} element={<SubtypeDP />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={SUBTYPE_DP_NEW}
                                        element={<SubtypeDPForm />}
                                    />
                                    <Route
                                        path={`${SUBTYPE_DP_EDIT}/:idSubtypeDP`}
                                        element={<SubtypeDPForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${SUBTYPE_DP_DETAIL}/:idSubtypeDP`}
                                element={<SubtypeDPDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={PQR_RECEPTION_CHANNEL}
                                element={<PqrReceptionChannel />}
                            />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PQR_RECEPTION_CHANNEL_NEW}
                                        element={<PqrReceptionChannelForm />}
                                    />
                                    <Route
                                        path={`${PQR_RECEPTION_CHANNEL_EDIT}/:idReceptionChannel`}
                                        element={<PqrReceptionChannelForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PQR_RECEPTION_CHANNEL_DETAIL}/:idReceptionChannel`}
                                element={<PqrReceptionChannelDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={PQR_RECEIVED_THROUGH}
                                element={<PqrReceivedThrough />}
                            />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PQR_RECEIVED_THROUGH_NEW}
                                        element={<PqrReceivedThroughForm />}
                                    />
                                    <Route
                                        path={`${PQR_RECEIVED_THROUGH_EDIT}/:idReceivedThrough`}
                                        element={<PqrReceivedThroughForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PQR_RECEIVED_THROUGH_DETAIL}/:idReceivedThrough`}
                                element={<PqrReceivedThroughDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={PRODUCT} element={<Product />} />
                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PRODUCT_NEW}
                                        element={<ProductForm />}
                                    />
                                    <Route
                                        path={`${PRODUCT_EDIT}/:idProduct`}
                                        element={<ProductForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PRODUCT_DETAIL}/:idProduct`}
                                element={<ProductDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={FRAUD_MODE} element={<FraudMode />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={FRAUD_MODE_NEW}
                                        element={<FraudModeForm />}
                                    />
                                    <Route
                                        path={`${FRAUD_MODE_EDIT}/:idFraudMode`}
                                        element={<FraudModeForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${FRAUD_MODE_DETAIL}/:idFraudMode`}
                                element={<FraudModeDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={FRAUD_TYPE} element={<FraudType />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={FRAUD_TYPE_NEW}
                                        element={<FraudTypeForm />}
                                    />
                                    <Route
                                        path={`${FRAUD_TYPE_EDIT}/:idFraudType`}
                                        element={<FraudTypeForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${FRAUD_TYPE_DETAIL}/:idFraudType`}
                                element={<FraudTypeDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={FUNCTIONARIES_SWITCHBOARD}
                                element={<FunctionariesSwitchboard />}
                            />

                            {[
                                'admin',
                                'supervisor',
                                'agente-conmutador',
                            ].includes(type) && (
                                <>
                                    <Route
                                        path={FUNCTIONARIES_SWITCHBOARD_NEW}
                                        element={<FunctionariesSwitchForm />}
                                    />
                                    <Route
                                        path={`${FUNCTIONARIES_SWITCHBOARD_EDIT}/:idFunctionariesSwitch`}
                                        element={<FunctionariesSwitchForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${FUNCTIONARIES_SWITCHBOARD_DETAIL}/:idFunctionariesSwitch`}
                                element={<FunctionariesSwitchDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route path={PQR_TIMES} element={<PqrTimes />} />

                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={PQR_TIMES_NEW}
                                        element={<PqrTimesForm />}
                                    />
                                    <Route
                                        path={`${PQR_TIMES_EDIT}/:idPqrTimes`}
                                        element={<PqrTimesForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${PQR_TIMES_DETAIL}/:idPqrTimes`}
                                element={<PqrTimesDetail />}
                            />
                        </Route>

                        <Route path={SYSTEMCONFIG} element={<PrivateRoute />}>
                            <Route
                                path={COMPLIANCE_TERMS}
                                element={<ComplianceTerms />}
                            />
                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={COMPLIANCE_TERMS_NEW}
                                        element={<ComplianceTermsForm />}
                                    />
                                    <Route
                                        path={`${COMPLIANCE_TERMS_EDIT}/:idComplianceTerm`}
                                        element={<ComplianceTermsForm />}
                                    />
                                </>
                            )}
                            <Route
                                path={`${COMPLIANCE_TERMS_DETAIL}/:idComplianceTerm`}
                                element={<ComplianceTermsDetail />}
                            />
                        </Route>

                        <Route path={USERS} element={<PrivateRoute />}>
                            {['admin', 'supervisor'].includes(type) && (
                                <Route path={USERLIST} element={<Users />} />
                            )}
                            {type === 'admin' && (
                                <>
                                    <Route
                                        path={USERNEW}
                                        element={<UserNew />}
                                    />
                                    <Route
                                        path={`${USEREDIT}/:idUser`}
                                        element={<EditUser />}
                                    />
                                </>
                            )}
                        </Route>
                        <Route path={UPDATE_PASSWORD} element={<PublicRoute />}>
                            <Route index element={<UpdatePasswordUser />} />
                        </Route>
                        {type === 'admin' && (
                            <Route element={<PrivateRoute />}>
                                <Route path={EXPORT} element={<Export />} />
                            </Route>
                        )}
                        <Route path={SIGNIN} element={<PublicRoute />}>
                            <Route index element={<SignIn />} />
                            <Route
                                path={EXPIRATIONTOKEN}
                                element={<ExpirationToken />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route path={CHATVIDEO} element={<ChatVideo />} />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route path={CHAT} element={<ChatWeb />} />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route path={CHAT_WEB} element={<ChatWebPage />} />
                        </Route>
                        {/* Chatbot simulation page */}
                        <Route element={<PublicRoute />}>
                            <Route
                                path={CHAT_BOT}
                                element={<ChatbotScript />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route path={PQRWEB} element={<PqrWeb />} />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route
                                path={PQRWEB_CREATE}
                                element={<PqrWebCreate />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route
                                path={PQRWEB_SEARCH}
                                element={<PqrFiltersWeb survey={false} />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route
                                path={PQRWEB_SURVEY}
                                element={<PqrFiltersWeb survey={true} />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route
                                path={`${PQRWEB_SURVEY_RESPONSE}/:idPqr`}
                                element={<PqrSurveyForm />}
                            />
                        </Route>
                        <Route element={<PublicRoute />}>
                            <Route
                                path={CHANNELSSMSFORM}
                                element={<ChannelsWeb />}
                            />
                        </Route>
                        <Route
                            path={CHANNELSMSFORMTHANKYOU}
                            element={<ChannelsWebThankYou />}
                        />
                        <Route
                            path={`${SURVEYS_RENDER}/:id/:caller_id?/:document_type?/:document_number?/:customer_name?/:associated_service?`}
                            element={<SurveyRender />}
                        />
                        <Route path={PAGENOTFOUND} element={<PageNotFound />} />
                    </Routes>
                </Router>
            )}
        </ThemeProvider>
    );
};

export default AppRoutes;
